import { render } from "./AddDocumentIcon.vue?vue&type=template&id=27655f6b"
import script from "./AddDocumentIcon.vue?vue&type=script&lang=js"
export * from "./AddDocumentIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__